module.exports = __webpack_public_path__ + "assets/img/tgsm5.c52ea3e8.png";